import React, { useState, useEffect } from 'react';
import WelcomePage from './Profile/WelcomePage';
import EditProfile from './Profile/EditProfile';
import { useOkta } from '../../hooks/oktaHook';
import SetupTeam from './SetupTeam';
import { fetchLastLoginDetails } from '../HomePage/service';

const ProfilePage = () => {
  const { userDetails } = useOkta();
  const [showProfileEdit, setShowProfileEdit] = useState(false);
  const [showsetupProfile, setShowsetupProfile] = useState(false);
  const getLastLoginData = async (email) => {
    const payload = {
      listOfAssignedBUs: userDetails?.BUs ?? [],
      userRole: userDetails?.roles?.[0]
    };
    try {
      const data = await fetchLastLoginDetails(email, payload);

      if (data) {
        setShowsetupProfile(false);
      } else {
        setShowsetupProfile(true);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  useEffect(() => {
    if (userDetails.email) {
      getLastLoginData(userDetails.email);
    }
  }, [userDetails]);
  return (
    <>
      {showsetupProfile ? (
        <>
          {showProfileEdit ? (
            <EditProfile userDetails={userDetails} />
          ) : (
            <WelcomePage
              handleTeamSetupClick={() => setShowProfileEdit(true)}
              userDetails={userDetails}
            />
          )}
        </>
      ) : (
        <SetupTeam />
      )}
    </>
  );
};
export default ProfilePage;
